import { get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export type PushCampaignSendPayload = {
  campaignName: string;
  recipientSegment: "all" | "users" | "attendants" | "single";
  title: string;
  body: string;
  audienceFilters?: string[];
  singleRecipientUserId?: string | null;
  testRecipientUserId?: string | null;
};

export type PushCampaignRecipientSearchResult = {
  userId: string;
  email: string;
  fullName: string | null;
  roleName: string;
};

export const useSendPushCampaign = (
  options?: UseMutationOptions<any, any, PushCampaignSendPayload, any>
) => {
  return useMutation<any, any, PushCampaignSendPayload, any>(async (data) => {
    return await post("push-campaign/send-push", data);
  }, options);
};

export const useGetPushCampaignAudienceSummary = (
  options?: UseMutationOptions<any, any, void, any>
) => {
  return useMutation<any, any, void, any>(async () => {
    return await get("push-campaign/audience-summary");
  }, options);
};

export const useSearchPushCampaignRecipients = (
  options?: UseMutationOptions<any, any, string, any>
) => {
  return useMutation<any, any, string, any>(async (query) => {
    return await get(`push-campaign/search-recipients?query=${encodeURIComponent(query)}`);
  }, options);
};
